<template>
  <section class="list-content" :class="{ 'loading-content': loading }">
    <div v-if="loading" class="loading">
      <loading />
      <p>{{ listResources.loading }}</p>
    </div>
    <header v-if="!loading">
      <h3>{{ listResources.header.title }}</h3>
    </header>
    <section v-if="!loading" class="cards-container">
      <actionPlanCard
        @cardClick="itemClick()"
        id="newActionPlan"
        class="action-card"
        :isNew="true"
      />
      <actionPlanCard
        class="action-card"
        v-for="template of templates"
        :key="template.id"
        :actionPlan="template"
        @cardClick="itemClick(template)"
      />
    </section>
  </section>
</template>
<script>
import actionPlanCard from '@/components/ActionPlan/ListTemplate/Card.vue'
import Loading from '@/components/Shared/Loading.vue'
import { mapGetters } from 'vuex'
import { ACTION_PLAN_EVENT_OPEN_FORM, TEMPLATES } from './Enum'
import { pluck, startWith } from 'rxjs/operators'
import { HIGH } from '@/helpers/messages-priority'

export default {
  subscriptions() {
    const actionPlans$ = this.$watchAsObservable('templates').pipe(
      pluck('newValue'),
      startWith(this.templates)
    )

    return {
      actionPlans$,
    }
  },
  data() {
    return {
      defaultActionPlan: {
        title: '',
        description: '',
      },
      loading: false,
    }
  },
  components: {
    actionPlanCard,
    Loading,
  },
  mounted() {
    this.loadTemplates()
  },
  computed: {
    ...mapGetters({
      templates: 'actionPlan/templates',
    }),
    listResources() {
      return this.$store.getters.resources.component.actionPlan.list
    },
  },
  methods: {
    itemClick(actionPlan) {
      if (actionPlan) {
        this.$store.dispatch('actionPlan/clearActionPlan')
        this.$store.dispatch('actionPlan/openPlanTemplate', actionPlan)
      } else {
        this.$store.dispatch('actionPlan/clearActionPlan')
      }
      this.$root.$emit(ACTION_PLAN_EVENT_OPEN_FORM, TEMPLATES.FORM_ACTION_PLANS)
    },
    loadTemplates() {
      const loadingFalse = () => (this.loading = false)
      this.loading = true

      this.$store
        .dispatch('actionPlan/loadTemplates')
        .then(loadingFalse)
        .catch(() => {
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.listResources.errorAPI,
            status: 'warning',
            countDown: 5,
          })
          loadingFalse()
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.loading-content {
  width: 100%;
  .loading {
    margin: 0 auto;
    text-align: center;
  }
}

.list-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px 50px;

  @include media-breakpoint-down(sm) {
    padding: 30px 0;
  }

  h3 {
    @include media-breakpoint-down(sm) {
      padding: 0 50px;
    }
  }

  h3,
  .cards-container {
    flex: 1 1 100%;
    overflow: auto;
  }

  .cards-container {
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    height: 85vh;

    @include media-breakpoint-down(sm) {
      height: 100%;
    }

    .action-card {
      border: 1px solid map-get($theme-colors, 'gray01');
      border-radius: 8px;
      color: map-get($theme-colors, 'primary');
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 240px;
      font-size: 16px;
      height: 332px;
      justify-content: space-between;
      margin: 0 5px 5px;
      max-width: 240px;
      cursor: pointer;

      @include media-breakpoint-down(sm) {
        margin: 0 auto 5px;
      }
    }
  }
}
</style>
